<template>
  <div class="interview">
    <el-dialog
      title="线索导入"
      :visible.sync="impVisible"
      width="600px"
      :close-on-click-modal="false"
      center
    >
      <el-row> 选择文件： <input type="file" ref="fileClue" /> </el-row><br />
      <div  v-html="errnoMsg"> </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="impVisible = false">取 消</el-button>
        <el-button type="primary" @click="importConfirm">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { regionData, regionDataPlus } from "element-china-area-data";
import moment from "moment";

import workercrmapi from "@/script/api/workercrmapi";
import globalData from "@/components/common/globaldata/global.data.vue";

let vm;
export default {
  data() {
    return {
      impVisible: false,
      errnoMsg: ""
    };
  },
  beforeCreate() {
    vm = this;
  },
  methods: {
    showImport() {
      this.impVisible = true;
      this.errnoMsg='';
    },
    importConfirm() {
      if (this.$refs.fileClue.files.length == 0) {
        this.$message.error("请选择上传文件");
        return;
      }
      this.errnoMsg='';

      var formData = new window.FormData();
      formData.append("file", this.$refs.fileClue.files[0]);

      workercrmapi.$axiosImport(formData)
        .then(res => {
          // console.log(res);
          if (res.data.errno == 0) {
            this.errnoMsg = res.data.data;
            this.$message.success("导入成功，请看页面详细结果");
            // this.impVisible = false;
            // this.$parent.querySearch();
          } else {
            this.errnoMsg = res.data.data;
            this.$message.error( res.data.data);
          }
        })
        .catch(err => {
          this.errnoMsg =  err.data.data;
        });
    }
  }
};
</script>
<style scoped></style>
